const requireComponent = require.context("./dislog", false, /\w+.(vue|js)$/);

const cmps = {};
//排除
const filterCmps = [];

requireComponent.keys().forEach((fileName) => {
  const cmp = requireComponent(fileName).default;
  !filterCmps.includes(fileName) && (cmps[cmp.name] = cmp);
});
import HisTable from "@/components/his";
import Laysuit from "./lawsuit/index"; //添加案件信息
import Count from "@/components/count";
import Beforetime from "./ndislog/beforetime"; //一审立案审查中
import Beforestart from "./ndislog/beforestart.vue";
import Police from "./ndislog/police.vue";
import Out from "@/components/out";
import Reason from "./ndislog/reason"; //作废原因
import InvalidTable from "./ndislog/invalidTable";
import Auction from "./auction";
import Share from "./btns/share"; //案件信息
import HisList from "./disList/HisList";
import CauseStepLog from "@/components/causeStepLog"; //操作记录
import OtherList from "./disList/Other"; //其他债务人信息
import CarList from "./disList/CarList"; //案涉标的物信息

const components = [
  HisTable,
  Laysuit,
  Count,
  Beforetime,
  Beforestart,
  Police,
  Out,
  Reason,
  InvalidTable,
  Auction,
  Share,
  HisList,
  OtherList,
  CauseStepLog,
  CarList,
];
components.map((fileName) => {
  const cmp = fileName;
  !filterCmps.includes(fileName) && (cmps[cmp.name] = cmp);
});

export default cmps;
